export default class Timeline {
    constructor() {
        this.initTimeline();
    }

    initTimeline() {
        const carousel = document.querySelector('.timeline');
        if (!carousel) {
            return;
        }
        new Swiper(carousel.querySelector('.swiper'), {
            slidesPerView: 1,
            spaceBetween: 15,
            autoHeight: true,
            navigation: {
                nextEl: carousel.querySelector('.swiper-button-next'),
                prevEl: carousel.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                782: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });
    }
}
  

